module.exports = __webpack_public_path__ + "img/badge-most-created-leads-keyvue-pink.d3c9a145.png";